// extracted by mini-css-extract-plugin
export default {"body":"DescriptionBlock_body__KC-88","divider":"DescriptionBlock_divider__OYYyD","header":"DescriptionBlock_header__V4W0j","readMore":"DescriptionBlock_readMore__LIpWU"};